"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsActionHeaderType = exports.NewsType = exports.NavigationType = void 0;
var NavigationType;
(function (NavigationType) {
    NavigationType["About"] = "About";
    NavigationType["Buy"] = "Buy";
    NavigationType["BuyingOptions"] = "BuyingOptions";
    NavigationType["Events"] = "Events";
    NavigationType["Forums"] = "Forums";
    NavigationType["GenericLink"] = "GenericLink";
    NavigationType["MoreEvents"] = "MoreEvents";
    NavigationType["MyAccount"] = "MyAccount";
    NavigationType["News"] = "News";
    NavigationType["Regulars"] = "Regulars";
    NavigationType["Reviews"] = "Reviews";
    NavigationType["Sell"] = "Sell";
    NavigationType["SellingOptions"] = "SellingOptions";
    NavigationType["Services"] = "Services";
    NavigationType["ServicesTools"] = "ServicesTools";
    NavigationType["Shop"] = "Shop";
    NavigationType["UserOptions"] = "UserOptions";
})(NavigationType = exports.NavigationType || (exports.NavigationType = {}));
var NewsType;
(function (NewsType) {
    NewsType["News"] = "News";
    NewsType["Regulars"] = "Regulars";
    NewsType["Reviews"] = "Reviews";
})(NewsType = exports.NewsType || (exports.NewsType = {}));
var AnalyticsActionHeaderType;
(function (AnalyticsActionHeaderType) {
    AnalyticsActionHeaderType["Account"] = "account";
    AnalyticsActionHeaderType["Buy"] = "buy";
    AnalyticsActionHeaderType["Events"] = "events";
    AnalyticsActionHeaderType["Forums"] = "forums";
    AnalyticsActionHeaderType["Logo"] = "logo";
    AnalyticsActionHeaderType["News"] = "news";
    AnalyticsActionHeaderType["Sell"] = "sell";
    AnalyticsActionHeaderType["Services"] = "services";
})(AnalyticsActionHeaderType = exports.AnalyticsActionHeaderType || (exports.AnalyticsActionHeaderType = {}));
//# sourceMappingURL=navigation.js.map